import { render, staticRenderFns } from "./OrderAdmittancePerformers.vue?vue&type=template&id=18aca419&scoped=true&"
import script from "./OrderAdmittancePerformers.vue?vue&type=script&lang=js&"
export * from "./OrderAdmittancePerformers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18aca419",
  null
  
)

export default component.exports
import {QBtn,QTable,QTr,QTh,QTd,QTooltip} from 'quasar'
component.options.components = Object.assign({QBtn,QTable,QTr,QTh,QTd,QTooltip}, component.options.components || {})
